class Accordion {
  constructor(selector = '.js-accordion', opt = {}) {
    this.selector = selector;
    this.multiple = opt.multiple || false;
    this.speed = opt.speed || 400;
    this.$accordions = $(selector);

    if (!this.$accordions.length) {
      return;
    }

    this.initState();
    this.event();
  }

  initState() {
    this.$accordions.each((_, accordion) => {
      $(accordion).find('.js-accordion-item').each((__, item) => {
        const $item = $(item);
        const $content = $item.find('.js-accordion-content');

        if (!$content.length) {
          return;
        }

        if ($item.hasClass('is-open')) {
          $content.show();
        } else {
          $content.hide();
        }
      });
    });
  }

  event() {
    this.$accordions.on('click', '.js-accordion-trigger', (e) => {
      e.preventDefault();

      const $trigger = $(e.currentTarget);
      const $item = $trigger.closest('.js-accordion-item');
      const $accordion = $trigger.closest(this.selector);
      const $content = $item.find('.js-accordion-content');

      if (!$content.length) {
        return;
      }

      const isOpen = $item.hasClass('is-open');

      if (isOpen) {
        $item.removeClass('is-open');
        $content.slideUp(this.speed);
        return;
      }

      if (!this.multiple) {
        $accordion.find('.js-accordion-item.is-open').each((_, openItem) => {
          const $openItem = $(openItem);

          if ($openItem.is($item)) {
            return;
          }

          $openItem.removeClass('is-open');
          $openItem.find('.js-accordion-content').slideUp(this.speed);
        });
      }

      $item.addClass('is-open');
      $content.slideDown(this.speed);
    });
  }
}
